<template>
  <div style="background-color: rgb(249, 249, 249);  width: 100%;">
    <div class="d-flex justify-center">
      <v-btn color="deep-purple" small text class="d-flex justify-center" @click="handleGetMainHeight">
        <v-icon size="30" color="deep-purple">mdi-chevron-down</v-icon>
      </v-btn>
    </div>
    <div class="pt-16 pb-16">
      <YA_SummarizerContent1 />
    </div>
    <!-- <div class="pt-16 pb-16">
      <YA_Customers />
    </div> -->
  </div>
</template>

<script>
import YA_SummarizerContent1 from '@/components/PowerSummarizer/YA_SummarizerContent1.vue';

export default {
  name: 'PowerSummarizerContent',
  components: {
    YA_SummarizerContent1,
  },
  data() {
    return {

    }
  },
  mounted() {

  },

  methods: {
    handleGetMainHeight() {
      this.$store.commit('HandlepowerSummarizerMainHeight', true);
    },
  }

};
</script>

<style scoped>

</style>